import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Alert } from '@material-ui/lab';
import { GlobalStore } from '@roc/feature-app-core';
import { CdaAndAppraisalOrderDetailsStore } from '@roc/feature-documents';
import { ONE_PAYMENT } from '@roc/feature-utils';
import { Button, TextField } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect } from 'react';

const useStyles = makeStyles({
  container: {
    paddingTop: 16,
  },
  instruction: {
    fontWeight: 600,
  },
});

type SecondaryValuationProps = {
  globalStore: GlobalStore;
  handleClose: () => void;
  loan: any;
  isInternal: boolean;
  cdaAndAppraisalOrderDetailsStore: CdaAndAppraisalOrderDetailsStore;
}


export const SecondaryValuation = observer((
  { globalStore, handleClose, loan, isInternal, cdaAndAppraisalOrderDetailsStore }: SecondaryValuationProps
) => {

  const firstPayment = loan.loanDepositData && loan.loanDepositData.depositReceived && (loan.loanDepositData.depositType === 'Appraisal_Standalone' || loan.loanDepositData.depositType === 'Appraisal_Loan');

  const handleCopy = () => {
    navigator.clipboard.writeText(cdaAndAppraisalOrderDetailsStore.secondAppraisalInformation?.paymentLink);
    if (isInternal) {
      window.parent.postMessage(cdaAndAppraisalOrderDetailsStore.secondAppraisalInformation?.paymentLink, '*');
    }
    globalStore.notificationStore.showSuccessNotification({
      message: 'Link was copied to clipboard!',
    });
  };

  const classes = useStyles();

  if (!cdaAndAppraisalOrderDetailsStore.secondAppraisalInformation) {
    return <></>;
  }

  return (<Grid container justifyContent="center" className={classes.container}>
    {(loan?.secondAppraisalPaymentType === ONE_PAYMENT && firstPayment) ? (
      <Grid item xs={11}>
        <Alert severity="success">Borrower has paid in advance.</Alert>
      </Grid>
    ) : (
      cdaAndAppraisalOrderDetailsStore.secondAppraisalInformation?.paid ? (<>
        <Grid item xs={11}>
          <Alert severity="success">All appraisals are paid for.</Alert>
        </Grid>
      </>) : (<>
        <Grid item container xs={11} spacing={2}>
          <Grid item>
            <Typography className={classes.instruction}>
              Link for the borrower to review and make the appraisal payment
            </Typography>
          </Grid>
          <Grid item container alignItems="center" spacing={2}>
            <Grid item xs={12} sm>
              <TextField
                testId="secondaryPaymentUrl"
                variant="outlined"
                label="Deposit URL"
                value={cdaAndAppraisalOrderDetailsStore.secondAppraisalInformation?.paymentLink}
                fullWidth
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={3} style={{ paddingRight: '0px' }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleCopy}
                testId="copySecondaryPaymentUrlButton"
                fullWidth
              >
                COPY LINK
              </Button>
            </Grid>
          </Grid>

        </Grid>
      </>)
    )}


    <Grid item container xs={11} justifyContent='flex-end' style={{ paddingTop: '16px' }}>
      <Grid item>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleClose}
          testId="cancel"
        >
          Close
        </Button>
      </Grid>
    </Grid>
  </Grid>
  )
});